import React from 'react';
import { Box, Card, CardContent, CardHeader, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SuccessMessage from '../../../components/successMessage';
import ErrorMessage from '../../../components/errorMessage';
import Loading from '../../../components/loading';
import LaboratoryListContent from './laboratoryListContent';
import { useLaboratoryListScreen } from '../hooks/useLaboratoryListScreen';

export default function LaboratoryListMobile() {
  const screen = useLaboratoryListScreen();
  const {
    isLoading,
    openCreateModal,
    showSuccessMessage,
    setShowSuccessMessage,
    successMessage,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
  } = screen;

  return (
    <>
      <Loading isToHidden={isLoading === false} />
      {showSuccessMessage && (
        <SuccessMessage
          message={successMessage}
          show={showSuccessMessage}
          setShow={setShowSuccessMessage}
        />
      )}
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <Box sx={{ p: 2 }}>
        <Card sx={{ borderRadius: '16px', boxShadow: 'none' }}>
          <CardHeader
            title="Laboratórios"
            titleTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'text.secondary' }}
          />
          <CardContent>
            <LaboratoryListContent screen={screen} />
          </CardContent>
        </Card>
      </Box>

      <Fab
        color="primary"
        aria-label="adicionar laboratório"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClick={openCreateModal}
      >
        <AddIcon />
      </Fab>
    </>
  );
}
